<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="6" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="light">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">Every Day Sale Report</h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false"
                >{{ geteveryDaySaleList.length }} Entries</small
              >
            </h5>
          </b-col>
          <b-col md="4">
            <b-button
              class="pull-right ml-1 mt-1"
              :variant="
                Filter.dateRange.startDate || Filter.dateRange.endDate
                  ? 'outline-danger'
                  : 'outline-primary'
              "
              :class="' ml-4' + visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4"
              @click="visible = !visible"
              style="font-size: 0.675rem"
              >{{
                Filter.dateRange.startDate || Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button
            >
            <b-button
              class="pull-right ml-1 mt-1"
              v-if="geteveryDaySaleList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="
                exportEveryDaySaleReportDashboard(
                  'geteveryDaySaleList',
                  'Export As Excel'
                )
              "
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >
              {{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button>
          </b-col>

          <b-col cols="12">
            <b-pagination
              limit="5"
              :total-rows="geteveryDaySaleList.length"
              :per-page="pagination.perPage"
              v-model="pagination.currentPage"
              class="my-0 pull-right"
            />
            <!-- <div>
          <b-pagination
            limit="25"
            align="center"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total-rows="geteveryDaySaleList.length"
            @change="onPageChange($event)"
          ></b-pagination>
        </div> -->
          </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker
                    :always-show-calendars="showCal"
                    v-model="Filter.dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    :disabled="Filter.DFlag ? true : false"
                    @update="getEveryDaySaleCard('Normal', '0', '0', '1', '1')"
                  ></date-range-picker>
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-button
                    size="sm"
                    style="margin-left: auto"
                    class="ml-1 pull-right"
                    @click="clearFilter"
                    variant="outline-danger"
                    >Reset</b-button
                  >
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Month Wise Amount</label>
              <b-table
                show-empty
                stacked="md"
                responsive
                :fields="EconomicMonthSaleFields"
                :items="getEconomicMonthSaleList"
                class="table-background position-relative"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
              >
                <template slot="SN" slot-scope="row0">
                  <span>{{
                    row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                  }}</span>
                </template>
              </b-table>
            </div>

            <div class="table-responsive tableMain gutr">
              <label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Every Day Wise Amount</label>
              <b-table
                show-empty
                stacked="md"
                responsive
                :fields="everyDaySaleFields"
                :items="geteveryDaySaleList"
                class="table-background position-relative"
                :per-page="pagination.perPage"
                :current-page="pagination.currentPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
              >
                <template slot="SN" slot-scope="row0">
                  <span>{{
                    row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                  }}</span>
                </template>
              </b-table>
            </div>
            <div>
              <b-pagination
                limit="5"
                :total-rows="geteveryDaySaleList.length"
                :per-page="pagination.perPage"
                v-model="pagination.currentPage"
                class="my-0 pull-right"
              />
              <!-- <b-pagination
            limit="25"
            align="center"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total-rows="geteveryDaySaleList.length"
            @change="onPageChange($event)"
          ></b-pagination> -->
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import UlipService from "../../services/UlipService.js";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { read, utils, writeFile } from "xlsx";
export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      this.$store.dispatch("setCurrentRoute", "/sale/every-day-sale-dash");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.getEveryDaySaleCard("Normal", "0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  mounted() {},
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},
  data() {
    return {
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      geteveryDaySaleList: [],
      getEconomicMonthSaleList: [],
      totalData: 0,
      everyDaySaleFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "economic_year",
          mainkey: "economic_year",
          label: "Year",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "month_name",
          mainkey: "month_name",
          label: "Month",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "day_name",
          mainkey: "day_name",
          label: "Day",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "every_date",
          mainkey: "every_date",
          label: "Date",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "total_for_day",
          mainkey: "total_for_day",
          label: "Amount",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],
      EconomicMonthSaleFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "economic_year",
          mainkey: "economic_year",
          label: "Year",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "month_name",
          mainkey: "month_name",
          label: "Month",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "month_start_date",
          mainkey: "month_start_date",
          label: "Start Date",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "month_end_date",
          mainkey: "month_end_date",
          label: "End Date",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "total_per_month",
          mainkey: "total_per_month",
          label: "Amount",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],
      pagination: {
        currentPage: 1,
        perPage: 30,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      Filter: {
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },
  computed: {},
  watch: {},
  methods: {
    clearFilter() {
      this.Filter = {
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },
    exportEveryDaySaleReportDashboard() {
      if (this.geteveryDaySaleList.length > 0) {
        this.ExcelBtnName = "Downloading....";
        let newSheetdata = [];
        this.geteveryDaySaleList.map((obj, index) => {
          let SN = parseInt(index) + parseInt(1);
          let economic_year = obj.economic_year;
          let month_name = obj.month_name;
          let day_name = obj.day_name;
          let every_date = obj.every_date;
          let total_for_day = obj.total_for_day;

          const newData = {
            SN: SN,
            economic_year: economic_year,
            month_name: month_name,
            day_name: day_name,
            every_date: every_date,
            total_for_day: total_for_day,
          };
          newSheetdata.push(newData);
        });
        let fileName = "Every_Day_sale_Master_Report_" + ".xlsx";
        const headings = [["SN", "Year", "Month", "Day", "Date", "Amount"]];
        const wb = utils.book_new();
        const ws = utils.json_to_sheet([]);
        utils.sheet_add_aoa(ws, headings);
        utils.sheet_add_json(ws, newSheetdata, { origin: "A2", skipHeader: true });
        utils.book_append_sheet(wb, ws, "Report");
        writeFile(wb, fileName);
        this.ExcelBtnName = "Export As Excel";
      }
    },
    getEveryDaySaleCard(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.geteveryDaySaleList = [];
      this.getEconomicMonthSaleList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "geteveryDaySaleList",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.pagination.perPage,
        Filter: this.Filter,
      };

      UlipService.getAllUlipList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.geteveryDaySaleList.length > 0) {
                this.totalData = data.totalData;
                this.geteveryDaySaleList = data.geteveryDaySaleList;
                this.getEconomicMonthSaleList = data.getEconomicMonthSaleList;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.geteveryDaySaleList.length > 0) {
                this.totalData = data.totalData;
                this.geteveryDaySaleList = data.geteveryDaySaleList;
                this.getEconomicMonthSaleList = data.getEconomicMonthSaleList;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on geteveryDaySaleList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() {},
    goBack() {
      window.history.go(-1);
    },
    filterClear() {
      this.Filter = {
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getEveryDaySaleCard("Normal", "0", "0", "1", "1");
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getEveryDaySaleCard("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getEveryDaySaleCard("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getEveryDaySaleCard("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getEveryDaySaleCard("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// saleEveryDayCard.vue?7ed8d0db